import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, getToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = logged out
  const [activeLocation, setActiveLocation] = useState(
    localStorage.getItem("tc_active_location") || null
  );

  const loadMe = useCallback(async () => {
    if (!getToken()) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setToken(null);
      setUser(false);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const pinLogin = async (email, pin) => {
    const { data } = await api.post("/auth/pin-login", { email, pin });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    setToken(null);
    setUser(false);
    localStorage.removeItem("tc_active_location");
  };

  const chooseLocation = (locId) => {
    setActiveLocation(locId);
    if (locId) localStorage.setItem("tc_active_location", locId);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, pinLogin, logout, loadMe, activeLocation, chooseLocation }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
